<template>
  <q-inner-loading v-if="reportLoading || organizationLoading" showing color="secondary" />
  <property-compare
    v-else
    ref="propertyCompare"
    :comparable-addresses="comparable_addresses"
    :subject="subject"
    :report="report"
  >
    <template #primay-button="{ hasPropertyReports, makeCopy }">
      <q-btn
        v-if="hasPropertyReports"
        no-caps
        unelevated
        color="accent"
        label="Copy Report"
        @click="
          () => {
            canLeaveSafely = true
            makeCopy(name)
          }
        "
      />
      <q-btn
        v-else
        no-caps
        unelevated
        color="primary"
        :to="{ name: 'Subscribe to Property Reports' }"
      >
        7-Day Free Trial
      </q-btn>
    </template>
  </property-compare>
</template>

<script lang="ts">
import type {
  PropertySearchResponse,
  PropertyComparableResponse,
  PropertyReportSubscriptionAttributes
} from 'common'
import { usePropertyReportStore } from '@/stores/propertyreport'
import PropertyCompare from '@/components/PropertyReports/PropertyCompare.vue'
import { useUserStore } from '@/stores/user'
import { isLoaded } from '@/utils/loading'

export default {
  name: 'PropertyReportOverviewView',
  components: {
    PropertyCompare
  },
  props: {
    reportId: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      name: '',
      report: null as PropertyReportSubscriptionAttributes | null,
      subject: null as PropertySearchResponse | null,
      comparable_addresses: [] as (PropertyComparableResponse | PropertySearchResponse)[],
      reportLoading: true,
      canLeaveSafely: false
    }
  },
  computed: {
    organizationLoading() {
      return useUserStore().organizationLoading
    }
  },
  watch: {
    reportId() {
      this.loadAll()
    }
  },
  created() {
    this.loadAll()
  },
  methods: {
    async loadAll() {
      this.reportLoading = true
      await usePropertyReportStore()
        .getReport(undefined, this.reportId, { logVisit: true })
        .then((response) => {
          if (isLoaded(response)) {
            this.report = response.data
            this.name = response.data.name
            this.subject = response.data.subject
            this.comparable_addresses = response.data.comparable_addresses
          } else {
            console.error('Report not found', this.reportId, response)
            this.$router.push({ name: 'Dashboard' })
          }
        })
        .finally(() => {
          this.reportLoading = false
        })
    }
  }
}
</script>
